import { CONTACT_STATUS_LABELS, type ContactStatus } from '../../types/lead.js';

// RELAY-ONLY CLUBS: a club whose leads are only sent on to its CRM (neither the AI SMS nor Speed to Lead is on). Nothing here
// ever contacts those leads, so "Not contacted" would be a false alarm. ⚠️ Decided from the club's STORED settings: a club with no
// settings doc has the defaults (both off), so it is relay-only too.

export function isRelayOnlyClub(settings: { samEnabled?: boolean; speedToLeadEnabled?: boolean } | null | undefined): boolean {
  return settings?.samEnabled !== true && settings?.speedToLeadEnabled !== true;
}

export const SENT_TO_CRM_LABEL = 'Sent to your CRM';

/** The contact line for a lead. A relay-only club's never-contacted lead reads "Sent to your CRM"; a lead that is in a conversation keeps its status. */
export function contactStatusLabel(status: ContactStatus, relayOnly: boolean): string {
  return status === 'not_contacted' && relayOnly ? SENT_TO_CRM_LABEL : CONTACT_STATUS_LABELS[status];
}
